/* eslint-disable react/function-component-definition */
import React from 'react';
import DownChevron from '@material-ui/icons/ExpandMore';
import { v2DropdownStyles } from '../../css/style';

const styles = v2DropdownStyles();

// Writing this as a function in order to match the signature of
// the Material UI Select.props.IconComponent
const DownChevronSelectToggle = onClick => () => (
  <DownChevron
    style={styles.chevron}
    onClick={onClick}
  />
);

export const DownChevronSelectToggleItems = onClick => () => (
  <DownChevron
    style={styles.chevronItems}
    onClick={onClick}
  />
);

export default DownChevronSelectToggle;
